import { GeneralHttpResponse } from "../types/genericTypes";
import axios from "axios";
import env from "react-dotenv";

export const getUsuarioPorIdHttp = async (datos?: any) => {
  try {
    const response = await axios.get(`${env.API_URL}/getUsuarioPorId`, {
      params: datos,
    });
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getUsuariosHttp = async (datos?: any) => {
  try {
    const response = await axios.get(`${env.API_URL}/getUsuarios`, {
      params: datos,
    });
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getUsuarioDatosPorIdHttp = async (datos?: number) => {
  try {
    const response = await axios.get(`${env.API_URL}/getUsuarioDatosPorId`, {
      params: datos,
    });
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};